import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Enveloppe de la liste des avis et de la page de personnalisation du formulaire. */
export const Route = createFileRoute('/_app/reviews')({
  component: () => <Outlet />,
});
